import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './AuthContext';
import { PermissionsProvider, usePermissions } from './PermissionsContext';
import ExternalLinks from './components/ExternalLinks';
import ControlPanel from './components/ControlPanel';

const ProtectedContent = () => {
  const { isAuthenticated, login, logout, user } = useAuth();
  const { showControlPanel, setShowControlPanel, hasControlPanelAccess, nameOverride, clearNameOverride } = usePermissions();

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <span className="brand-mark">T</span>
        <p className="eyebrow">Authorized employees only</p>
        <h1>CNTA Technology Portal</h1>
        <button onClick={login} className="login-button">
          <span className="microsoft-mark" aria-hidden="true"><i /><i /><i /><i /></span>
          Sign in with Microsoft
        </button>
      </div>
    );
  }

  const canAccessControlPanel = hasControlPanelAccess(user?.name);

  return (
    <div className="app-content">
      <div className="header">
        <h1>CNTA Technology Portal</h1>
        <div className="user-info">
          <span>Welcome, {user?.name}</span>
          {nameOverride && (
            <button 
              onClick={clearNameOverride} 
              className="clear-override-button"
              title="Stop testing and return to your account"
            >
              Stop Testing as {nameOverride}
            </button>
          )}
          {canAccessControlPanel && (
            <button 
              onClick={() => setShowControlPanel(true)} 
              className="control-panel-button"
              title="Manage Permissions"
            >
              Control Panel
            </button>
          )}
          <button onClick={logout} className="logout-button">Sign Out</button>
        </div>
      </div>
      <ExternalLinks />
      {showControlPanel && <ControlPanel />}
      {/* <WeeklySessionForm /> */}
    </div>
  );
};

const RedirectPage = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" /> : <div>Processing login...</div>;
};

function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/redirect" element={<RedirectPage />} />
              <Route path="/" element={<ProtectedContent />} />
            </Routes>
          </div>
        </Router>
      </PermissionsProvider>
    </AuthProvider>
  );
}

export default App;
